import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  HostListener,
  OnInit,
} from "@angular/core";
import { EmailService } from "../email.service";
import { HotToastService } from "@ngneat/hot-toast";

import { EmailMessage } from "../email.types";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AutosizeModule } from "ngx-autosize";
import { FormsModule } from "@angular/forms";
import { ChipModule } from "primeng/chip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { NgIf, NgClass } from "@angular/common";
import { Editor, EditorModule } from "primeng/editor";
import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ButtonModule } from "primeng/button";
import { SkeletonModule } from "primeng/skeleton";
import { AutoCompleteModule } from "primeng/autocomplete";
import { SharedDataService } from "../../shared-data.service";
@Component({
  selector: "email-form",
  templateUrl: "./email-form.component.html",
  styleUrls: [
    "./email-form.component.scss",
    "../email-content/email-content.component.scss",
    "../email.component.scss",
  ],
  imports: [
    NgIf,
    NgClass,
    BsDropdownModule,
    ChipModule,
    FormsModule,
    AutosizeModule,
    EditorModule,
    DialogModule,
    ProgressSpinnerModule,
    ButtonModule,
    SkeletonModule,
    AutoCompleteModule,
  ],
})
export class EmailFormComponent implements OnInit {
  @Input() composeMode: any = false;

  @Output() moveToTrash = new EventEmitter();
  @Output() cancelCompose = new EventEmitter<void>();

  private _newEmailMode: boolean;
  private _thread: EmailMessage;
  emailBodyAnimationinterval: NodeJS.Timeout;

  @Input() set newEmailMode(value: boolean) {
    this._newEmailMode = value;

    if (this.newEmailMode) {
      console.log(this.emailService.settings);
      this.newEmail.body =
        "<br><br><br><br>" + this.emailService.settings.signature;

      console.log(this.newEmail);

      setTimeout(() => {
        console.log(this.messageInput.getQuill());
        this.messageInput.getQuill().focus();
      }, 100);

      // setTimeout(() => {
      //   const element: Element = (this.messageInput!.contentModule as any)
      //     .getDocument()
      //     .getElementsByClassName("e-content")[0];
      //   const selectioncursor: NodeSelection = new NodeSelection();
      //   const range: Range = document.createRange();

      //   let firstBrIndex = 0;
      //   for (let i = 0; i < element.childNodes[0].childNodes.length; i++) {
      //     if (element.childNodes[0].childNodes[i].nodeName == "BR") {
      //       firstBrIndex = i;
      //       break;
      //     }
      //   }

      //   range.setStart(
      //     element.childNodes[0].childNodes[firstBrIndex] as any,
      //     0
      //   );
      //   selectioncursor.setRange(document, range);
      // });
    }
  }

  get newEmailMode(): boolean {
    return this._newEmailMode;
  }

  @Input() set thread(value: EmailMessage) {
    this._thread = value;

    if (this.thread) {
      this.emailService.getInboxSettings(this.thread.inbox).subscribe((res) => {
        this.emailService.settings.signature = res["signature"];
        this.emailService.settings.greeting = res["greeting"];
        this.cdr.detectChanges();
      });

      this.newEmail = {
        to: [],
        cc: [],
        bcc: [],
        subject: "",
        body: "",
      };

      if (this.thread.messages[this.thread.messages.length - 1] != null) {
        if (
          this.thread.messages[this.thread.messages.length - 1]["cc"] != null
        ) {
          this.newEmail.cc = this.thread.messages[
            this.thread.messages.length - 1
          ]["cc"].map((address) => {
            return address.address;
          });
        }
      }

      this.newEmail.to.push(this.thread.from_email.address);
    }
  }

  get thread(): EmailMessage {
    return this._thread;
  }

  @ViewChild("messageInput")
  messageInput: Editor;

  @ViewChild("magicReplyInput") magicReplyInput: any;

  to: any = null;
  subject: any = null;
  message: any = null;

  modifiedMessage: any = null;

  summary = false;
  cc = false;
  bcc = false;
  summarizeLoading = false;
  generateAiLoading = false;
  changeEmailToneLoading = false;
  generateMagicEmailLoading = false;
  generateMagicEmailInitialState = true;
  showEmailBodyActions = false;
  animateEditor = false;

  newEmail: any = {
    to: [],
    cc: [],
    bcc: [],
    subject: "",
    body: "",
  };

  position: string;
  aiComposerVisible: boolean = false;
  animateAIDialog: boolean = false;
  showEmailBody = false;
  typingSpeed: number = 10; // Default typing speed
  aiComposerDraft: string = "";

  magicReplyPrompt: string = "";
  public bsModalRef: BsModalRef;

  isEditingEmailBody: boolean = false;

  constructor(
    private emailService: EmailService,
    private toastr: HotToastService,
    private cdr: ChangeDetectorRef,
    private sharedDataService: SharedDataService,
    public modalService: BsModalService,
  ) {}

  ngOnInit(): void {
    console.log("newEmail", this.newEmail);
    this.clearEmailDraft();
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.generateMagicEmail();
    }
  }

  setComposeMode(mode, onlySender = false) {
    this.composeMode = mode;

    if (this.composeMode == true) {
      this.newEmail.body =
        this.emailService.settings.greeting +
        "\n\n" +
        this.emailService.settings.signature;

      setTimeout(() => {
        console.log(this.messageInput);
        this.messageInput.getQuill().focus();
      }, 10);
    }

    if (!this.newEmailMode) {
      this.newEmail.subject = "Re: " + this.thread.subject;
    }

    // --- Reply logic ---
    if (
      !this.newEmailMode &&
      this.thread &&
      this.thread.messages &&
      this.thread.messages.length > 0
    ) {
      const lastMsg = this.thread.messages[this.thread.messages.length - 1];
      const currentUserEmail = this.sharedDataService.user.email;
      // fallback: try sharedDataService if needed

      // Always clear recipients first
      this.newEmail.to = [];
      this.newEmail.cc = [];
      this.newEmail.bcc = [];

      if (onlySender) {
        // Reply only to sender
        if (lastMsg.from_email?.address) {
          this.newEmail.to = [lastMsg.from_email.address];
        }
      } else {
        // Reply all: to all recipients except current user
        let toList = (lastMsg.to || []).map((r) => r.address);
        let ccList = (lastMsg.cc || []).map((r) => r.address);
        // Remove current user from all lists
        toList = toList.filter((addr) => addr && addr !== currentUserEmail);
        ccList = ccList.filter((addr) => addr && addr !== currentUserEmail);
        // Add sender if not current user
        if (
          lastMsg.from_email?.address &&
          lastMsg.from_email.address !== currentUserEmail
        ) {
          toList.unshift(lastMsg.from_email.address);
        }
        // Remove duplicates
        toList = Array.from(new Set(toList));
        ccList = Array.from(new Set(ccList));
        this.newEmail.to = toList;
        this.newEmail.cc = ccList;
        // bcc left empty
      }
    }
  }

  cancelComposeMode() {
    this.setComposeMode(false);
    this.cancelCompose.emit();
  }

  sendEmail() {
    this.emailService
      .sendEmail(
        this.newEmail.to,
        this.newEmail.subject,
        this.modifiedMessage != null
          ? this.modifiedMessage
          : this.newEmail.body,
        this.newEmail.cc,
        this.newEmail.bcc,
        this.newEmailMode
          ? null
          : this.thread.messages[this.thread.messages.length - 1][
              "internal_id"
            ],
      )
      .subscribe(
        (data: any) => {
          this.message = null;
          this.modifiedMessage = null;
          this.toastr.success("Email sent");

          this.newEmail = {
            to: [],
            cc: [],
            bcc: [],
            subject: "",
            body: "",
          };

          this.setComposeMode(false);
          this.emailService.newEmailSent$.next(true);
        },
        (err) => {
          this.toastr.error(err.error.message);
        },
      );
  }

  summarizeThread() {
    this.summarizeLoading = true;
    this.emailService
      .summarizeThread(this.thread.uuid)
      .subscribe((res: any) => {
        console.log(res);

        this.thread.summary = res.summary;
        this.summarizeLoading = false;
      });
  }

  changeEmailTone(tone) {
    const button = Array.from(document.querySelectorAll("button")).find(
      (btn) => btn.textContent?.trim() === "Change tone",
    );
    if (button) {
      button.classList.add("button-loading");
      button.disabled = true;
    }

    this.aiComposerVisible
      ? (this.animateAIDialog = true)
      : (this.animateEditor = true);

    if (this.emailBodyAnimationinterval) {
      clearInterval(this.emailBodyAnimationinterval);
    }

    this.generateMagicEmailLoading = true;
    this.generateMagicEmailInitialState = false;
    this.showEmailBody = false;
    this.showEmailBodyActions = false;

    this.emailService
      .changeEmailTone(
        this.aiComposerVisible ? this.aiComposerDraft : this.newEmail.body,
        tone,
        this.thread != null ? this.thread.uuid : null,
      )
      .then(
        (res: any) => {
          this.magicReplyPrompt = "";
          this.aiComposerDraft = "";
          const animatedText = res.email;
          if (this.aiComposerVisible) {
            this.animateAIComposer(animatedText, true);
          } else {
            this.animateGeneratedEmail(animatedText, false);
          }
        },
        (err) => {
          this.toastr.error("Error changing email tone. Please try again");
          this.animateEditor = false;
          this.animateAIDialog = false;
        },
      )
      .finally(() => {
        this.magicReplyPrompt = "";
        this.aiComposerVisible ? (this.showEmailBody = true) : null;
        this.generateMagicEmailLoading = false;
        if (button) {
          button.classList.remove("button-loading");
          button.disabled = false;
        }
      });
  }

  generateMagicEmail(prompt = this.magicReplyPrompt, event = null) {
    if (event) {
      event.target.classList.add("button-loading");
      event.target.disabled = true;
    }
    this.generateMagicEmailLoading = true;
    this.generateMagicEmailInitialState = false;
    this.showEmailBody = false;
    this.showEmailBodyActions = false;
    this.magicReplyPrompt = "";
    this.aiComposerDraft = "";
    clearInterval(this.emailBodyAnimationinterval);
    this.emailService
      .magicEmail(prompt, !this.newEmailMode ? this.thread.uuid : null)
      .subscribe(
        (res: any) => {
          this.animateAIComposer(res.email, true);
          this.bsModalRef.hide();
        },
        (err) => {
          this.toastr.error(
            "Error generating magic response. Please try again",
          );
        },
        () => {
          this.magicReplyPrompt = "";
          this.showEmailBody = true;
          this.generateMagicEmailLoading = false;
          if (event) {
            event.target.classList.remove("button-loading");
            event.target.disabled = false;
          }
        },
      );
  }

  quickAction(prompt, event) {
    console.log("newEmail", this.newEmail);
    event.target.classList.add("button-loading");
    event.target.disabled = true;
    this.animateEditor = true;

    if (this.emailBodyAnimationinterval) {
      clearInterval(this.emailBodyAnimationinterval);
    }

    this.emailService
      .magicEmail(prompt, !this.newEmailMode ? this.thread.uuid : null)
      .subscribe(
        (res: any) => {
          this.animateGeneratedEmail(res.email);
          this.bsModalRef.hide();
        },
        (err) => {
          this.toastr.error(
            "Error generating magic response. Please try again",
          );
        },
        () => {
          event.target.classList.remove("button-loading");
          event.target.disabled = false;
        },
      );
  }

  animateAIComposer(text: string, showActions = false) {
    if (
      this.emailService.settings.greeting != null &&
      this.emailService.settings.greeting != ""
    ) {
      this.aiComposerDraft = this.emailService.settings.greeting + "<br><br>";
    }
    this.showEmailBody = false;
    this.showEmailBodyActions = false;
    this.animateAIDialog = true;

    if (!showActions) {
      this.showEmailBodyActions = false;
      this.generateMagicEmailInitialState = true;
    }
    let index = 0;
    this.emailBodyAnimationinterval = setInterval(() => {
      if (index < text.length) {
        if (text[index] === "\n") {
          this.aiComposerDraft += "<br>";
        } else {
          this.aiComposerDraft += text[index];
        }
        this.aiComposerDraft +=
          '<span class="cursor-ai-composer" style="color: #9745ff !important; display: inline">█</span>';
        setTimeout(() => {
          this.aiComposerDraft = this.aiComposerDraft.replace(
            '<span class="cursor-ai-composer" style="color: #9745ff !important; display: inline">█</span>',
            "",
          );
        }, this.typingSpeed - 2);
        index++;
      } else {
        clearInterval(this.emailBodyAnimationinterval);
        if (
          this.emailService.settings.signature != null &&
          this.emailService.settings.signature != "" &&
          this.emailService.settings.signature != "<p></p>"
        ) {
          this.aiComposerDraft +=
            "<br><br>" + this.emailService.settings.signature;
        }
        this.animateAIDialog = false;
        this.animateEditor = false;
        // TODO: this if can be written in a better way
        if (!showActions) {
          this.showEmailBodyActions = false;
          this.generateMagicEmailInitialState = true;
        } else {
          this.showEmailBodyActions = true;
        }
      }
    }, this.typingSpeed); // Adjust typing speed as needed
  }

  animateGeneratedEmail(text: string, showActions = false) {
    this.newEmail.body = "";
    if (
      this.emailService.settings.greeting != null &&
      this.emailService.settings.greeting != ""
    ) {
      this.newEmail.body = this.emailService.settings.greeting + "<br><br>";
    }
    this.showEmailBody = false;
    this.showEmailBodyActions = false;
    this.animateAIDialog = true;

    if (!showActions) {
      this.showEmailBodyActions = false;
      this.generateMagicEmailInitialState = true;
    }
    let index = 0;
    this.emailBodyAnimationinterval = setInterval(() => {
      if (index < text.length) {
        if (text[index] === "\n") {
          this.newEmail.body += "<br>";
        } else {
          this.newEmail.body += text[index];
        }
        this.newEmail.body +=
          '<span style="color: #9745ff !important; display: inline">█</span>';
        setTimeout(() => {
          this.newEmail.body = this.newEmail.body.replace(
            '<span style="color: #9745ff !important; display: inline">█</span>',
            "",
          );
        }, this.typingSpeed - 2);
        index++;
      } else {
        clearInterval(this.emailBodyAnimationinterval);
        if (
          this.emailService.settings.signature != null &&
          this.emailService.settings.signature != "" &&
          this.emailService.settings.signature != "<p></p>"
        ) {
          this.newEmail.body +=
            "<br><br>" + this.emailService.settings.signature;
        }
        this.animateAIDialog = false;
        this.animateEditor = false;
        // TODO: this if can be written in a better way
        if (!showActions) {
          this.showEmailBodyActions = false;
          this.generateMagicEmailInitialState = true;
        } else {
          this.showEmailBodyActions = true;
        }
      }
    }, this.typingSpeed); // Adjust typing speed as needed
  }

  openModal(template) {
    this.bsModalRef = this.modalService.show(template, {
      class: "create-ai-job-modal modal-md",
    });
  }

  openAIComposerDialog() {
    this.animateAIDialog = false;
    this.position = "bottom";
    this.aiComposerVisible = true;
    setTimeout(() => {
      this.magicReplyInput.nativeElement.focus();
    }, 200);
  }

  toggleEmailBodyEdit() {
    this.isEditingEmailBody = true;
    setTimeout(() => {
      const editableDiv = document.querySelector(
        ".generated-email-editable",
      ) as HTMLDivElement;
      if (editableDiv) {
        editableDiv.focus();
      }
    }, 0);
  }

  saveDraftEdit() {
    this.isEditingEmailBody = false;
    this.aiComposerDraft = (
      document.querySelector(".generated-email-editable") as HTMLDivElement
    ).innerHTML;
  }

  clearEmailDraft() {
    this.aiComposerDraft = "";
    this.aiComposerVisible = false;
    this.showEmailBody = false;
    this.showEmailBodyActions = false;
    this.generateMagicEmailInitialState = true;
  }

  insertEmailBodyFromDraft() {
    this.newEmail.body = this.aiComposerDraft;
    this.clearEmailDraft();
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const text = event.clipboardData?.getData("text/plain");
    document.execCommand("insertText", false, text);
  }

  addChipOnBlur(chipList: string[], event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value.trim();
    if (value && !chipList.includes(value)) {
      chipList.push(value);
    }
    inputElement.value = ""; // Clear the input field
  }

  addChipOnComma(chipList: string[], event: KeyboardEvent): void {
    if (event.key === ",") {
      event.preventDefault(); // Prevent the default comma input
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value.trim();
      if (value && !chipList.includes(value)) {
        chipList.push(value);
      }
      inputElement.value = ""; // Clear the input field
    }
  }
}
